<template>
  <base-dialog v-model="dialog.show" max-width="720px" scrollable width="60%">
    <template v-slot:title>
      {{ dialog.title }} {{ $t('sidebar.raster-source.name') }}
    </template>
    <base-form ref="form" @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.name"
            autofocus
            :error-messages="dialog.errors.name"
            label="Tên hiển thị"
            required
            filled
            dense
            @focus="dialog.errors.name = ''"
          ></field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.description"
            :error-messages="dialog.errors.description"
            label="Mô tả"
            filled
            dense
            rows="3"
            type-input="v-textarea"
            @focus="dialog.errors.description = ''"
          ></field-group>
        </v-col>
        <v-col cols="12" class="pt-2">
          <div class="d-flex align-center mb-2">
            <div class="subtitle-2">Metadata</div>
            <v-spacer></v-spacer>
            <base-button small text color="primary" @click="addMetadataRow">
              <v-icon left small>mdi-plus</v-icon>
              Thêm dòng
            </base-button>
          </div>
          <v-simple-table dense>
            <thead>
              <tr>
                <th style="width: 40%">Trường</th>
                <th>Giá trị</th>
                <th style="width: 56px"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in dialog.form.metadata"
                :key="row.id || 'new-' + index"
              >
                <td class="pa-1">
                  <v-text-field
                    v-model="row.field"
                    dense
                    filled
                    hide-details
                    placeholder="Tên trường"
                  ></v-text-field>
                </td>
                <td class="pa-1">
                  <v-text-field
                    v-model="row.value"
                    dense
                    filled
                    hide-details
                    placeholder="Giá trị"
                  ></v-text-field>
                </td>
                <td class="pa-1 text-center">
                  <v-btn icon small @click="removeMetadataRow(index)">
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr v-if="!dialog.form.metadata || !dialog.form.metadata.length">
                <td class="grey--text text-center py-4" colspan="3">
                  Chưa có metadata. Nhấn "Thêm dòng" để nhập.
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </base-form>
    <template v-slot:extra-btn>
      <base-button color="primary" :loading="dialog.loading" @click="onSubmit">
        {{ dialog.title }}
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { API_RASTER_SOURCE } from '@api'
import { copyByJson } from '@utils'
import { EDIT_TYPE } from '@/src/constant'

export default {
  data: () => ({
    dialog: {
      show: false,
      form: {
        metadata: [],
      },
      errors: {},
      title: '',
      type: '',
      loading: false,
    },
  }),
  computed: {
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    normalizeMetadata(metadata) {
      if (Array.isArray(metadata)) {
        return metadata.map((item) => ({
          id: item && item.id != null ? String(item.id) : '',
          field: item && item.field != null ? String(item.field) : '',
          value: item && item.value != null ? item.value : '',
        }))
      }
      if (metadata && typeof metadata === 'object') {
        return Object.keys(metadata).map((key) => ({
          id: '',
          field: key,
          value: metadata[key],
        }))
      }
      return [{ id: '', field: '', value: '' }]
    },
    addMetadataRow() {
      if (!Array.isArray(this.dialog.form.metadata)) {
        this.$set(this.dialog.form, 'metadata', [])
      }
      this.dialog.form.metadata.push({ id: '', field: '', value: '' })
    },
    removeMetadataRow(index) {
      this.dialog.form.metadata.splice(index, 1)
    },
    open(item, type = EDIT_TYPE.CREATE) {
      const copied = copyByJson(item || {})
      this.dialog.show = true
      this.dialog.form = Object.assign(
        { name: '', description: '', metadata: [] },
        copied,
        { metadata: this.normalizeMetadata(copied.metadata) }
      )
      this.dialog.title = this.$t('actions.' + type)
      this.dialog.type = type
      this.dialog.errors = {}
      this.dialog.loading = false
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        form: { metadata: [] },
        type: EDIT_TYPE.CREATE,
        errors: {},
      }
    },
    async onSubmit() {
      if (!(await this.$refs['form'].validate())) {
        return false
      }
      try {
        const data = Object.assign({}, this.dialog.form, {
          metadata: (this.dialog.form.metadata || [])
            .filter((row) => String(row.field || '').trim() !== '')
            .map((row) => {
              const item = {
                field: String(row.field).trim(),
                value: row.value,
              }
              if (row.id) {
                item.id = row.id
              }
              return item
            }),
        })
        this.dialog.loading = true
        let res = this.isCreateDialog
          ? await API_RASTER_SOURCE.create(data)
          : await API_RASTER_SOURCE.update(data.id, data)

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.errors = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>
